<div class="body">
  <div class="top-bar">
    <div class="content-start"></div>
    <div class="logo-div">
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <select
        [value]="currentLanguage"
        (change)="languageChange($event)"
        class="select-dropdown"
      >
        <option
          *ngFor="let option of languageOptions"
          [value]="option?.value"
          [selected]="option.value === currentLanguage"
        >
          {{ option.value }}
        </option>
      </select>
    </div>
  </div>
  <div class="h-full relative show-bottom-fade">
    <div class="h-full min-h-0 border-b border-white">
      <div class="max-w-xl mx-auto pt-2 px-4">
        <div class="header pt-2 pb-2 headermain">
          {{ translations['dishmachine_model_type'] }}
        </div>
        <div class="mb-3">
          <label class="label pb-1"
            >{{ translations['dishmachine_label'] }}
          </label>
        </div>
        <div class="dishmachine-container">
          <div
            class="dishmachine-option"
            *ngFor="let machine of dishmachineOptions"
            [class.selected]="
              accountDetails?.selectedMachineType === machine.value
            "
            (click)="onMachineSelect(machine)"
          >
            <div class="input-div">
              <input
                type="radio"
                id="{{ machine.value }}"
                name="dishmachine"
                [value]="machine.value"
                [checked]="
                  accountDetails?.selectedMachineType === machine.value
                "
                (change)="onMachineSelect(machine)"
                (click)="$event.stopPropagation()"
              />
            </div>
            <div>
              <label for="{{ machine.value }}">
                <img
                  [src]="machine.image"
                  [alt]="machine.label"
                  class="dishmachine-img"
                />
              </label>
            </div>
            <div>{{ machine.label }}</div>
          </div>
          <div
            class="dishmachine-option"
            *ngFor="let item of unsupportedMachines"
          >
            <div class="input-div machine-type">
              <input
                type="radio"
                id="{{ item.value }}"
                name="dishmachine"
                [value]="item.value"
                disabled
              />
            </div>
            <div class="machine-type">
              <label for="{{ item.value }}">
                <img
                  [src]="item.image"
                  [alt]="item.label"
                  class="dishmachine-img"
                />
              </label>
            </div>
            <div class="machine-type">{{ item.label }}</div>
            <div class="type-label machine-type">{{ item.type }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
